module.exports = __webpack_public_path__ + "img/Bath.73f0fd04.jpg";